<!-- 覆盖率情况 -->
<template>
  <div>
    <a-card size="small" :bordered="true" style="border: 1px solid #ccc; padding: 10px; border-radius: 4px;">
      <template slot="title">
        <span style="margin-right: 4px">CI覆盖率</span>
      </template>
      <div :id="id" :style="{ height: height, width: width }" />
    </a-card>
  </div>
</template>

<script>
import { getCiCoverageData } from '@/api/data/quality';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      id: 'ci-coverage',
      loading: false,
      showModal: 'team',
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<b>' + params[1].name + '</b><br/>';
            formatter += ' 整体' + params[1].seriesName + '<span style="float: right; margin-left:16px"><b style="color: #5A6FC0;">' + params[1].value + '</b> %</span><br/>';
            return formatter;
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      data: []
    };
  },
  watch: {
    filterForm: {
      handler() {
        this.getCiCoverage();
      },
      immediate: true, // 立即执行一次
      deep: true
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/grid');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById(this.id));
    const self = this;
    this.myChart.getZr().on('click', params => {
      const pointInPixel = [params.offsetX, params.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (self.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        // this.$refs.teamIssueAverageModalRef.open(this.data[index], this.data[index].issues_detail);
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用 */
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      setTimeout(() => {
        this.myChart.resize();
      }, 0);
    },
    getCiCoverage() {
      if (this.loading) return; // 如果正在加载数据，直接返回
      this.loading = true;
      getCiCoverageData({ ...this.filterForm }).then(
        res => {
          this.data = res.data.items;
          const x_axis = [];
          const ci_coverage = [];
          const dataShadow = [];
          const yMax = 100;
          if (this.filterForm.teams.length === 0) {
            this.data.forEach(el => {
              x_axis.push(this.showModal === 'team' ? el.team_name : el.nickname);
              ci_coverage.push(el.service_coverage_average);
              dataShadow.push(yMax);
            });
          } else {
            this.data.forEach(el => {
              el.coverage_detail.forEach(cov => {
                const service_name = Object.keys(cov)[0];
                x_axis.push(service_name);
                ci_coverage.push(cov[service_name].coverage.replace('%', ''));
                dataShadow.push(yMax);
              });
            });
          }
          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              // 背景系列
              type: 'bar',
              itemStyle: { color: 'rgba(180, 180, 180, 0.2)' }, // 背景色
              barGap: '-100%', // 使得背景系列与主数据系列重叠
              data: dataShadow, // 使用最大值作为数据以填充整个图表
              animation: false, // 关闭渲染动画，可提高性能
              barWidth: '50%'
            },
            {
              // 主数据系列
              type: 'bar',
              showBackground: false, // 关闭ECharts默认背景
              barWidth: '50%',
              label: {
                show: true,
                position: 'top',
                formatter: '{c}%'
              },
              name: '覆盖率',
              data: ci_coverage
            }
          ];
          this.drawChart();
        }
      ).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
